export const Logo = ({ className = "", size = 28 }) => {
    return (
        <div className={`inline-flex items-center gap-2 ${className}`} data-testid="sayz-logo">
            <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
                <rect x="1" y="1" width="30" height="30" rx="8" stroke="currentColor" strokeWidth="1.5" />
                <path
                    d="M10 11.5C10 9.567 11.567 8 13.5 8H22V11.5H13.5V14.5H18.5C20.433 14.5 22 16.067 22 18V20.5C22 22.433 20.433 24 18.5 24H10V20.5H18.5V17.5H13.5C11.567 17.5 10 15.933 10 14V11.5Z"
                    fill="currentColor"
                />
                <circle cx="24.5" cy="22.5" r="2" fill="hsl(var(--brand-accent))" />
            </svg>
            <span className="font-display text-lg font-bold tracking-tight">Sayz</span>
        </div>
    );
};

export default Logo;
